import React from 'react';
import { IIconProps } from '../interfaces';

const AleaChevronRightIcon: React.FC<IIconProps> = ({
  color = '#2B4956',
  size = '50',
}) => {
  const width = parseInt(String(size), 10);
  const height = width;

  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 50 50" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M21.6665 32L28.6665 25L21.6665 18" 
        stroke={color} 
        strokeWidth="1.33333" 
        strokeLinecap="round"
      />
    </svg>
  );
};

export default AleaChevronRightIcon; 